import React from 'react';

import '#root/common.css';
import '#components/header.css';

export const Header = ({subtitle, title}) => (
  <div className="header">
    <h1 className="header--title">{title}</h1>
    {subtitle && <h2 className="header--subtitle">{subtitle}</h2>}
  </div>
);

